<router-outlet></router-outlet>
<cwc-cobrowse  *ngIf="showCobrowse"
[license]="cobrowseLicense"
[codeMessage]="translation.pt('views.cobrowse.code_message')"
[requestAccessTitle]="translation.pt('views.cobrowse.request_access_title')"
[requestAccessMessage]="translation.pt('views.cobrowse.request_access_message')"
[remoteAccessTitle]="translation.pt('views.cobrowse.remote_control_title')"
[remoteControlMessage]="translation.pt('views.cobrowse.remote_control_message')"
[allowButtonText]="translation.pt('views.cobrowse.allow_button_text')"
[denyButtonText]="translation.pt('views.cobrowse.deny_button_text')"
[endSessionButtonText]="translation.pt('views.cobrowse.end_session_button_text')"
></cwc-cobrowse>